import GlpCard from './GlpCard.vue'

export { GlpCard }
